import { h } from 'preact'
import InputGroup from '../ui-components/InputGroup'
import ButtonControl from '../button-control'
import AbstractProvider, { ProvidedItems } from './AbstractProvider'
import { SetupProps } from './types'

const OAuth2Setup = (props: SetupProps) =>
  <AbstractProvider {...props}>
    {({ configuration, onSubmit, getError, getSubmitButtonProps, onInputChange, onCheckboxChange } : ProvidedItems) =>
      <div className='form-enumeration'>
        <div className='form-enumeration__number'>1</div>
        <div className='form-enumeration__step-title'>Go to your {props.provider.label} provider application and provide the
              following information.
        </div>
        <div className='form-enumeration__step-line' />
        <div className='form-enumeration__step-empty' />
        <div className='form-enumeration__number'>2</div>
        <div className='form-enumeration__step-title'>Provide {props.provider.label} credentials</div>
        <div />
        <div className='form-enumeration__step-content'>
          <p>Once you fill in these details and press 'Save changes', users on the community will be able to login
                using SSO, given all the information is provided is correct.</p>
          <form onSubmit={onSubmit}>
            <div>
              {props.provider.fields.map(field => {
                return field.type === 'checkbox'
                  ? <InputGroup
                    title={field.label}
                    type={field.type}
                    checked={configuration[field.name]} inline
                    onChangeCheckbox={(e: ChangeEvent) => onCheckboxChange(field.name, e.target.checked)}
                  />
                  : <InputGroup
                    title={field.label}
                    type={field.type}
                    value={configuration[field.name]}
                    onChangeCallback={(e: ChangeEvent) => onInputChange(field.name, e.target.value)}
                    error={getError(field.name) || undefined}
                  />
              })}
            </div>
            <div>
              <ButtonControl {...getSubmitButtonProps()} />
              <ButtonControl
                title='Cancel'
                variant='secondary'
                onClick={() => window.location.assign('/integration/sso')}
              />
            </div>
          </form>
        </div>
      </div>
    }
  </AbstractProvider>

export default OAuth2Setup
